(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pk-subscription-tabbing"] && !Shopify.designMode) return;
  try {
    


document.addEventListener('click', (event) => {

  const tab = event.target.closest('.package-tabbing .tab-btn');

  if (!tab) return;

  const root = tab.closest('.package-tabbing');

  root.querySelectorAll('.tab-btn').forEach((btn) => {

    btn.classList.remove('active');

  });

  root.querySelectorAll('.tab-content').forEach((pane) => {

    pane.classList.remove('active');

  });

  tab.classList.add('active');

  const pane = root.querySelector(
    `[data-tab-panel="${tab.dataset.tab}"]`
  );

  if (pane) {

    pane.classList.add('active');

  }

});


document.addEventListener('click', async (event) => {

  const button = event.target.closest('.package-subscribe-btn');

  if (!button || button.getAttribute('aria-busy') === 'true') return;

  const variantId = Number(button.dataset.variantId);

  const sellingPlanId = Number(button.dataset.sellingPlanId);

  if (!variantId || !sellingPlanId) return;

  const root = button.closest('.package-tabbing');

  const clearUrl =
    (root && root.dataset.cartClearUrl) ||
    '/cart/clear';

  const addUrl =
    (root && root.dataset.cartAddUrl) ||
    '/cart/add';

  button.setAttribute('aria-busy', 'true');

  try {

    await fetch(`${clearUrl}.js`, {
      method: 'POST'
    });

    const response = await fetch(`${addUrl}.js`, {

      method: 'POST',

      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },

      body: JSON.stringify({

        items: [
          {
            id: variantId,
            quantity: 1,
            selling_plan: sellingPlanId
          }
        ]

      })

    });

    const data = await response.json();

    if (
      !response.ok ||
      !data.items ||
      !data.items.length
    ) {

      console.error(
        'Subscription add to cart failed',
        data
      );

      button.setAttribute(
        'aria-busy',
        'false'
      );

      return;

    }

    window.location.href = '/checkout';

  } catch (error) {

    console.error(
      'Subscription add to cart failed',
      error
    );

    button.setAttribute(
      'aria-busy',
      'false'
    );

  }

});


/* ==========================================================
   BIRDIE AVENUE — LUXURY ENTRY BONUS COUNTDOWN
========================================================== */


const renderMultiplierCountdown = () => {

  document
    .querySelectorAll(
      '.package-tabbing[data-multiplier-ends-at]'
    )
    .forEach((root) => {

      const targets =
        root.querySelectorAll(
          '[data-multiplier-countdown]'
        );

      if (!targets.length) return;

      const endsAt =
        Number(root.dataset.multiplierEndsAt) *
        1000;

      const remaining =
        endsAt > 0
          ? endsAt - Date.now()
          : 0;

      if (remaining <= 0) {

        targets.forEach((el) => el.remove());

        return;

      }


      const totalSeconds =
        Math.floor(
          remaining / 1000
        );


      const days =
        Math.floor(
          totalSeconds / 86400
        );


      const hours =
        Math.floor(
          (totalSeconds % 86400) / 3600
        );


      const minutes =
        Math.floor(
          (totalSeconds % 3600) / 60
        );


      const seconds =
        totalSeconds % 60;


      const multiplier =
        root.querySelector(
          '.multiplier-badge-text'
        )?.textContent.trim() || '3X';


      targets.forEach((el) => {

        el.innerHTML = `

          <span class="bonus-countdown-label">
            ${multiplier} ENTRY BONUS ACTIVE
          </span>

          <span class="bonus-countdown-time">

            <span class="bonus-time-group">

              <span class="bonus-time-number">
                ${String(days).padStart(2, '0')}
              </span>

              <span class="bonus-time-unit">
                D
              </span>

            </span>

            <span class="bonus-time-separator">
              :
            </span>

            <span class="bonus-time-group">

              <span class="bonus-time-number">
                ${String(hours).padStart(2, '0')}
              </span>

              <span class="bonus-time-unit">
                H
              </span>

            </span>

            <span class="bonus-time-separator">
              :
            </span>

            <span class="bonus-time-group">

              <span class="bonus-time-number">
                ${String(minutes).padStart(2, '0')}
              </span>

              <span class="bonus-time-unit">
                M
              </span>

            </span>

            <span class="bonus-time-separator">
              :
            </span>

            <span class="bonus-time-group">

              <span class="bonus-time-number">
                ${String(seconds).padStart(2, '0')}
              </span>

              <span class="bonus-time-unit">
                S
              </span>

            </span>

          </span>

        `;

      });

    });

};


renderMultiplierCountdown();


setInterval(
  renderMultiplierCountdown,
  1000
);


document.addEventListener(
  'shopify:section:load',
  renderMultiplierCountdown
);



  } catch(e) { console.error(e); }
})();
})();
